import React, { useState, useEffect } from 'react';
import '../css/SessionExpirationModal.css';
import GlobalButton from '../util/GlobalButton';

const SessionExpirationModal = ({ isOpen, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="session-expiration-overlay">
      <div className="session-expiration-modal">
        <div className="modal-header">
          <h2>Session Expired</h2>
        </div>
        <div className="modal-body">
          <p>Your session has expired due to inactivity.</p>
          <p>Please log in again to continue.</p>
        </div>
        <div className="modal-footer">
          <GlobalButton
            action='login'
            onClick={onConfirm}
          >
            Login Again
          </GlobalButton>
        </div>
      </div>
    </div>
  );
};

export default SessionExpirationModal;
